export enum UserDataAccessLevel {
	Normal = 'Normal',
	Admin = 'Admin',
	Operator = 'Operator',
}

export enum UserPermissions {
	OPERATOR_UTILITY = '@OPERATOR_UTILITY',
}
